// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__UlSxT","left":"StickyBox_left__1Du_K","right":"StickyBox_right__2u6Qv"};